// extracted by mini-css-extract-plugin
module.exports = {"semesterRow":"Umk_semesterRow__1dl6A","tableContainer":"Umk_tableContainer__KW4P_","tableU":"Umk_tableU__3npeC","tableContent":"Umk_tableContent__39mbh"};